import React, { Component } from "react";
import { FormattedMessage, defineMessages, FormattedNumber, FormattedDate } from "react-intl";
import styles from "./ScheduledPayment.module.less";
import DetailList, { DetailListItem } from "../../../../../presentational/DetailList/DetailList";
import { cancelPayment } from "../../../../../../domain/payment/paymentActions";
import { connect } from "react-redux";
import classNames from "classnames";
import StatusMessage from "../../../../../presentational/StatusMessage";
import Confirm from "../../../../../presentational/Confirm/Confirm";
import ContactInfo from "../../../../../presentational/ContactInfo/ContactInfo";
import PaymentCancelDisclosure from "../../../../../presentational/PaymentCancelDisclosure/PaymentCancelDisclosure";
import AccountNumber from "assets/scripts/components/presentational/AccountNumber/AccountNumber";
const messages = defineMessages({
    paymentAmount: {
        id: "account.balanceSummary.scheduledPayment.paymentAmount",
        defaultMessage: "Payment Amount"
    },
    paymentDate: {
        id: "account.balanceSummary.scheduledPayment.paymentDate",
        defaultMessage: "Payment Date"
    },
    from: {
        id: "account.balanceSummary.scheduledPayment.from",
        defaultMessage: "From"
    },
    error: {
        id: "account.balanceSummary.scheduledPayment.error",
        defaultMessage: "Payment could not be cancelled due to this error:"
    }
});
class ScheduledPayment extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            confirmCancel: false
        };
        this._handleCancelOk = () => {
            this.props.onCancel(this.props.payment.id);
            this._hideConfirmCancel();
        };
        this._showConfirmCancel = () => {
            this.setState({ confirmCancel: true });
        };
        this._hideConfirmCancel = () => {
            this.setState({ confirmCancel: false });
        };
    }
    render() {
        const { payment, isCancelling, error } = this.props;
        return (<div>
				<h3 className="hdg vr vr_x1">
					<FormattedMessage id="account.balanceSummary.scheduledPayment.heading" defaultMessage="Scheduled Payment"/>
				</h3>
				<div className={styles.container}>
					<StatusMessage isError isActive={error != null} error={error} customMessage={messages.error}/>
					<div className="vr vr_x3">
						<DetailList>
							<DetailListItem label={messages.paymentAmount}>
								<FormattedNumber value={payment.amount} style="currency" currency="USD"/>
							</DetailListItem>
							<DetailListItem label={messages.paymentDate}>
								<FormattedDate value={payment.dateUtc}/>
							</DetailListItem>
							<DetailListItem label={messages.from}>
								<AccountNumber value={payment.redactedAccountNumber}/>
							</DetailListItem>
						</DetailList>
					</div>
					<div className="vr vr_x2">
						<button type="button" className={classNames("btn mix-btn_fixedWidth js-modal-btnTrigger", {
            btn_isDisabled: isCancelling // eslint-disable-line camelcase
        })} onClick={this._showConfirmCancel} data-modaltriggerid="cancel-payment-confirm" disabled={isCancelling}>
							<FormattedMessage id="account.balanceSummary.scheduledPayment.cancelPayment" defaultMessage="Cancel Payment"/>
						</button>
					</div>
					<StatusMessage isLoad isActive={isCancelling}/>
					<div className="text mix-text_small">
						<ContactInfo />
						<PaymentCancelDisclosure />
					</div>
				</div>

				<Confirm open={this.state.confirmCancel} triggerId="cancel-payment-confirm" onOk={this._handleCancelOk} onCancel={this._hideConfirmCancel}>
					<FormattedMessage id="account.balanceSummary.scheduledPayment.cancelConfirm" defaultMessage="Cancel scheduled payment?"/>
				</Confirm>
			</div>);
    }
}
export default connect((state, ownProps) => {
    const applicable = state.payment.cancel.id === ownProps.payment.id;
    return {
        isCancelling: applicable && state.payment.cancel.isCancelling,
        error: applicable ? state.payment.cancel.error : null
    };
}, {
    onCancel: cancelPayment
})(ScheduledPayment);



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/Account/BalanceSummary/ScheduledPayment/ScheduledPayment.tsx